import Playground from 'components/Playground';
import Carousel from "components/Carousel";
import * as React from 'react';
export default {
  Playground,
  Carousel,
  React
};